import { graphqlRequest, UNAUTHORIZED_ACTION_MESSAGE } from './graphqlClient';
import { BASE_DATA_QUERY, MY_PROFILE_QUERY } from '@/graphql/queries/user';
import { Role } from '@/types/index';
import { AssignedProjectUser, Language, QueryProjectUsersArgs, User } from '@/graphql/types';
import { GET_PROJECT_USERS } from '@/graphql/queries/project_users';
import { showToast } from '@/utils/utils';
import { errorMessages } from '@/utils/errorMessages';

interface InitialDataResponse {
  roles: Role[];
  languages: Language[];
}

export const fetchProfile = async () => {
  try {
    const { myProfile } = await graphqlRequest<object, { myProfile: User }>(
      MY_PROFILE_QUERY,
      {},
      'network-only',
    );
    return myProfile;
  } catch {
    return null;
  }
};

export const fetchProjectUsers = async (projectId: number) => {
  try {
    const response = await graphqlRequest<QueryProjectUsersArgs, { projectUsers: AssignedProjectUser[] }>(
      GET_PROJECT_USERS,
      { projectId },
      'network-only',
    );
    const { projectUsers }: { projectUsers: AssignedProjectUser[] } = response;
    return projectUsers;
  } catch (error) {
    if ((error as { message?: string })?.message !== UNAUTHORIZED_ACTION_MESSAGE) {
      showToast(errorMessages.fetchingProjectUsers, 'error');
    }
  }
};

export const fetchInitialData = async () => {
  const response = await graphqlRequest<Record<string, never>, InitialDataResponse>(
    BASE_DATA_QUERY,
  );

  const roles: InitialDataResponse = response;

  return roles;
};
